import React from 'react'
import { type OAuth2App } from '../../../store/auth/auth'
import { type ScopeItem } from '../utils/scopeMetadata'
import { OAuthAppIcons } from './OAuthAppIcons'
import { OAuthUserBar } from './OAuthUserBar'
import { OAuthScopeList } from './OAuthScopeList'
import { OAuthFooter } from './OAuthFooter'
import { Button } from '../../../components/Button/Button'

interface OAuthConsentViewProps {
  oauth2App: OAuth2App
  scopeGroups: Map<string, ScopeItem[]>
  userName: string
  isAuthorizing: boolean
  onAccept: () => void
  onCancel: () => void
}

export const OAuthConsentView: React.FC<OAuthConsentViewProps> = ({ oauth2App, scopeGroups, userName, isAuthorizing, onAccept, onCancel }) => {
  return (
    <>
      <OAuthAppIcons imageUrl={oauth2App.imageUrl} appName={oauth2App.name} />

      <h3 className='fw-bold text-center oauth-mb-40'>{oauth2App.name} wants access to Zocks</h3>

      <OAuthUserBar userName={userName} />

      <div className='text-muted fw-medium mb-4'>What {oauth2App.name} can access:</div>

      <OAuthScopeList scopeGroups={scopeGroups} />

      <OAuthFooter />

      <div className='oauth-buttons d-flex justify-content-end gap-3'>
        <Button variant='secondaryGhostButton' onClick={onCancel} disabled={isAuthorizing}>
          Cancel
        </Button>
        <Button variant='primary' onClick={onAccept} loading={isAuthorizing}>
          Accept
        </Button>
      </div>
    </>
  )
}
